export const downloadS3File = (s3Url: string, fileName: string) => {
  if (!s3Url || !/^https?:\/\//.test(s3Url)) {
    alert("다운로드 가능한 URL이 없습니다.");
    return;
  }

  const link = document.createElement("a");
  link.href = s3Url;
  link.download = fileName;
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
